import { orchestrator } from 'satcheljs';
import { onOpenHeaderPane } from 'owa-app-pane-group-actions';
import getDrawerPaneId from 'owa-app-pane-group-utils/lib/getDrawerPaneId';
import { headerButtons } from '../components/buttons/headerButtons';
import logMissingHeaderButtonPaneError from '../utils/logMissingHeaderButtonPaneError';
import openHeaderPane from './openHeaderPane';

orchestrator(onOpenHeaderPane, ({ headerPaneName, targetWindow }) => {
    const paneId = getDrawerPaneId(headerPaneName);
    const headerButton = headerButtons.find(button => button.pane?.id === paneId);

    if (!headerButton) {
        logMissingHeaderButtonPaneError(headerPaneName, paneId);
        return;
    }

    openHeaderPane(paneId, targetWindow);
});
